import * as React from 'react';
import { Button, Input, Checkbox, Typography, Card, ConfigProvider } from 'antd';
import ForgotPassword from './components/ForgotPassword';
import { signin } from '../../auth/auth.service';
import { brandingConfig } from '../../theme/brandingConfig';
import { lightTheme } from '../../theme/themeConfig';
import './Signin.css';

const { Title, Text, Paragraph } = Typography;

export default function SignIn(props) {
  const [emailError, setEmailError] = React.useState(false);
  const [emailErrorMessage, setEmailErrorMessage] = React.useState('');
  const [passwordError, setPasswordError] = React.useState(false);
  const [passwordErrorMessage, setPasswordErrorMessage] = React.useState('');
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = React.useState("");
  const [password, setPassword] = React.useState("");
  const [error, setError] = React.useState("");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError("");

    setEmailError(false);
    setEmailErrorMessage('');
    setPasswordError(false);
    setPasswordErrorMessage('');

    let isValid = true;

    if (!email || !/\S+@\S+\.\S+/.test(email)) {
      setEmailError(true);
      setEmailErrorMessage('Please enter a valid email address.');
      isValid = false;
    }

    if (!password || password.length < 6) {
      setPasswordError(true);
      setPasswordErrorMessage('Password must be at least 6 characters long.');
      isValid = false;
    }

    if (!isValid) {
      return;
    }

    try {
      await signin(email, password);
      window.location.href = "/";
    } catch (err) {
      setError(err.message);
    }
  };

  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (emailError && value) {
      setEmailError(false);
      setEmailErrorMessage('');
    }
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
    if (passwordError && value) {
      setPasswordError(false);
      setPasswordErrorMessage('');
    }
  };

  return (
    <ConfigProvider theme={lightTheme}>
      <div
        className="signin-container"
        style={{ '--signin-bg-image': `url(${brandingConfig.assets.signinBackground})` }}
      >
        <div className="signin-left">
          <div className="welcome-content">
            <div className="welcome-label">Partner Portal</div>
            <Title className="welcome-title">
              Welcome to the<br />
              <span className="italic-integrator">AirSmart </span> 
              Partner Portal
            </Title>
            <Paragraph className="welcome-subtitle">
              Your central hub for AirSmart training, system courses, and key project resources designed for installers and partners.
            </Paragraph>
          </div>
          <div className="welcome-footer">
            <div className="tagline">Architecture Defines Space. AirSmart Makes It Liveable.</div>
          </div>
        </div>

        <div className="signin-right">
          <div className="login-box">
            <Card className="login-card">
              <div className="login-logo-wrapper">
                <img src="/signin.svg" alt="AirSmart Logo" className="login-logo" />
              </div>
              <Title level={3} className="login-title">
                Sign in
              </Title>
              <div className="login-subtitle">Access your partner dashboard</div>
              
              <form
                onSubmit={handleSubmit}
                noValidate
                className="login-form"
              >
                <div className="form-item">
                  <label htmlFor="email">Email</label>
                  <Input
                    id="email"
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    autoComplete="email"
                    autoFocus
                    size="large"
                    value={email}
                    onChange={handleEmailChange}
                    status={emailError ? 'error' : ''}
                  />
                  {emailError && (
                    <Text type="danger" className="error-text">{emailErrorMessage}</Text>
                  )}
                </div>
                
                <div className="form-item">
                  <div className="label-wrapper">
                    <label htmlFor="password">Password</label>
                    <Button
                      type="link"
                      onClick={handleClickOpen}
                      className="forgot-password-link"
                    >
                      Forgot password?
                    </Button>
                  </div>
                  <Input.Password
                    id="password"
                    name="password"
                    placeholder="••••••"
                    autoComplete="current-password"
                    size="large"
                    value={password}
                    onChange={handlePasswordChange}
                    status={passwordError ? 'error' : ''}
                  />
                  {passwordError && (
                    <Text type="danger" className="error-text">{passwordErrorMessage}</Text>
                  )}
                </div>
                
                <div className="form-options">
                  <Checkbox>Remember me</Checkbox>
                </div>
                
                {error && <Text type="danger" className="global-error">{error}</Text>}
                
                <ForgotPassword open={open} handleClose={handleClose} />
                
                <Button
                  type="primary"
                  htmlType="submit"
                  block
                  size="large"
                  className="signin-submit-btn"
                >
                  Sign in
                </Button>
              </form>
            </Card>
          </div>

          <div className="become-integrator-footer">
            <Button 
              className="become-integrator-btn"
              href="https://airsmart.com/contact-airsmart/"
              target="_blank"
            >
              Become an partner
            </Button>
          </div>
        </div>
      </div>
    </ConfigProvider>
  );
}
